import { Navigate, Outlet, useLocation } from "react-router-dom";
import cookiesModifier from "../utils/cookies";

// import auth from "../utils/auth";

const PrivateRoutes = () => {
    const location = useLocation();

    // const tokenValidationRes = auth.isAuthTokenValid();
    const tokenValidationRes = { result: cookiesModifier.getCookie('imm_admin_token'), reason: 'not_found' };

    return (
        tokenValidationRes.result
            ? <Outlet />
            : <Navigate to='/login' state={{ from: location }} replace />
        // : tokenValidationRes.reason === 'not_found'
        //     // ? <Navigate to='/auth' state={{ from: location }} replace />
        //     // : <Navigate to={`/redirect-login?reason=${tokenValidationRes.reason}_token`} replace />
        //     ? <Navigate to='/' state={{ from: location }} replace />
        //     : <Navigate to='/' state={{ from: location }} replace />
    );
};

export default PrivateRoutes;